import { render, staticRenderFns } from "./MainBlocksSettings.vue?vue&type=template&id=ee0699f8&scoped=true&"
import script from "./MainBlocksSettings.vue?vue&type=script&lang=js&"
export * from "./MainBlocksSettings.vue?vue&type=script&lang=js&"
import style0 from "./MainBlocksSettings.vue?vue&type=style&index=0&id=ee0699f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0699f8",
  null
  
)

export default component.exports